import { Helmet } from "react-helmet-async";

function SEO({ title, description, image, keywords }) {
    let currentLanguage = 'en';
    if (navigator.language === 'ko') {
        currentLanguage = 'ko';
        document.documentElement.lang = 'ko';
    } else {
        document.documentElement.lang = 'en';
    }

    const siteName          = '뮤지직 MUSIZIC';
    const defaultImage      = '/assets/images/logo.webp';
    const defaultKewords    = currentLanguage === 'ko' ? '인디 뮤지션, 홍보, 네트워킹, 커뮤니케이션 플랫폼' : 'Promotion, Networking, Communication hub, Independent musicians';
    const defaultDescription= currentLanguage === 'ko' ? 'MUSIZIC은 인디 뮤지션을 위한 홍보, 네트워킹, 커뮤니케이션 플랫폼입니다.' : 'A promotion, networking, and communication hub for independent musicians.';

    return (
        <Helmet>
            <title>{ title ? ` ${ title } | ${ siteName }` : siteName }</title>
            <meta name="description" content={ description || defaultDescription } key='description' />
            <meta name="keywords" content={ keywords || defaultKewords } key='keywords' />

            <meta property="og:title" content={ title || siteName } key='og-title' />
            <meta property="og:description" content={ description || defaultDescription } key='og-description' />
            <meta property="og:image" content={ image || defaultImage } key='og-image' />
            <meta property="og:type" content="website" key='og-type' />

            {/* Twitter Card (트위터 공유) */}
            <meta name="twitter:card" content="summary_large_image" key="twitter-card" />
            <meta name="twitter:title" content={ title || siteName } key="twitter-title" />
            <meta name="twitter:description" content={ description || defaultDescription } key="twitter-description" />
            <meta name="twitter:image" content={ image || defaultImage } key="twitter-image" />

            {/* Canonical URL (중복 콘텐츠 방지) */}
            <link rel="canonical" href={ window.location.href } key="canonical" />

            {/* 반응형 웹 설정 */}
            <meta name="viewport" content="width=device-width, initial-scale=1" key="viewport" />

            {/* Charset & Language */}
            <meta charSet="UTF-8" key="charset" />
            <meta httpEquiv="Content-Language" content={ currentLanguage } key="content-language" />

            {/* 검색엔진 크롤링 설정 */}
            <meta name="robots" content="index, follow" key="robots" />
        </Helmet>
    );
}

export default SEO;